import { Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { InputLabel, FormControl, Select, MenuItem } from "@mui/material";

function MuiHeader({
  header,
  NavbarStatus,
  usertype_select_option_list,
  usertype_select_onchange,
  usertype,
}) {
  return (
    <div
      className="title-header"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div>{header.toUpperCase()}</div>

      {NavbarStatus && (
        <>
          User type
          <FormControl
            sx={{ width: "100%" }}
            style={{ width: "130px" }}
            size="small"
          >
            <InputLabel id="usertype-select-label">User type</InputLabel>
            <Select
              labelId="usertype-select-label"
              id="usertype-select"
              value={usertype}
              label="Fellow"
              onChange={usertype_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype_select_option_list?.map((option) => (
                <MenuItem key={option?.value} value={option?.value}>
                  {option?.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}
    </div>
  );
}

export default MuiHeader;
